var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearResult(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83388 9.09965C2.31318 9.62031 2.31318 10.4645 2.83388 10.9852L5.4058 13.5572H3.22441C2.85622 13.5572 2.55774 13.8556 2.55774 14.2238C2.55774 14.592 2.85622 14.8905 3.22441 14.8905H13.8911C14.2592 14.8905 14.5578 14.592 14.5578 14.2238C14.5578 13.8556 14.2592 13.5572 13.8911 13.5572H7.80444L14.1476 7.21398C14.6683 6.69331 14.6683 5.84909 14.1476 5.32839L11.3192 2.49996C10.7984 1.97926 9.95424 1.97926 9.43357 2.49996L2.83388 9.09965ZM5.71776 8.10138L3.77669 10.0424L6.60512 12.8708L8.54617 10.9298L5.71776 8.10138ZM6.66057 7.15856L9.48897 9.98698L13.2048 6.2712L10.3764 3.44277L6.66057 7.15856Z",
    fill: "#525866"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearResult);
export default __webpack_public_path__ + "static/media/clear-result.9debf846bf54abeeb174f1d50c248479.svg";
export { ForwardRef as ReactComponent };